import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {FinalDecisionComponent} from "./final-decision.component";

const routes: Routes = [
  {
    path: 'final',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: FinalDecisionComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FinalDecisionRoutingModule { }
